import { j as o } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as r } from "react";
import { I as i } from "../../../../IconBase-CxZyIWw2.js";
const l = r((e, a) => /* @__PURE__ */ o.jsx(
  i,
  {
    ref: a,
    ...e,
    image: (s) => /* @__PURE__ */ o.jsx(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16",
        ...s,
        children: /* @__PURE__ */ o.jsx(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M11.46 13.705a1.005 1.005 0 0 1-.664 1.256c-.53.163-.964-.164-1.256-.665C8.5 12.51 6.5 10.01 3 10.01c0 0-.222-.011-1-.011a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h10.465a1.91 1.91 0 0 1 1.682.973C14.733 3.029 16 5.686 16 9a1 1 0 0 1-1 1h-3.325a1 1 0 0 0-.956 1.294zM5 3H3v5h2z",
            clipRule: "evenodd"
          }
        )
      }
    )
  }
));
l.displayName = "ThumbsDownIcon";
export {
  l as ThumbsDownIcon,
  l as default
};
//# sourceMappingURL=index.js.map
